import getSystemConfiguration from "./systemConfiguration";

export function getRegexRulesForField(fieldName) {
    return Object.entries(getSystemConfiguration())
        .filter(key => key.toString().toLowerCase().startsWith(fieldName + "pattern"));
}